/* eslint-disable max-len */

export const deepLinkMobile: Map<string, string> = new Map<string, string>([
    ['APP-THERMO2_ANDROID', '/thermo/v2/user-registration-done'],
    ['APP-THERMO2_IOS', '/thermo/v2/user-registration-done'],
    ['APP-MYACCESS_ANDROID', '/myaccess/user-registration-done'],
    ['APP-MYACCESS_IOS', '/myaccess/user-registration-done'],
]);


